import React from 'react';
import Skeleton from './Skeleton';

export const WordListSkeleton = () => (
  <div className="min-h-[100dvh]">
    <div className="w-full px-2 sm:px-3 lg:px-4 py-4 sm:py-6 space-y-4">
      {/* Header bar */}
      <div className="bg-white border border-[var(--rule)] p-4">
        <div className="flex items-center justify-between mb-4">
          <Skeleton variant="text" width="140px" height="28px" />
          <Skeleton variant="rect" width="100px" height="36px" />
        </div>
        <div className="flex gap-2">
          <Skeleton variant="rect" width="100%" height="40px" />
        </div>
      </div>
      {/* Word cards */}
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="bg-white border border-[var(--rule)] p-4">
          <div className="flex items-center gap-3">
            <Skeleton variant="rect" width="20px" height="20px" />
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <Skeleton variant="text" width="120px" height="20px" />
                <Skeleton variant="rect" width="60px" height="22px" />
              </div>
              <Skeleton variant="text" width="200px" height="14px" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const StatsPageSkeleton = () => (
  <div className="min-h-[100dvh]">
    <div className="w-full px-2 sm:px-3 lg:px-4 py-4 sm:py-6 space-y-4">
      {/* Tab bar */}
      <div className="bg-white border border-[var(--rule)] p-4">
        <div className="flex gap-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="rect" width="80px" height="36px" />
          ))}
        </div>
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-white border border-[var(--rule)] p-4">
            <Skeleton variant="text" width="60px" height="12px" className="mb-2" />
            <Skeleton variant="text" width="80px" height="28px" />
          </div>
        ))}
      </div>
      {/* Chart placeholder */}
      <div className="bg-white border border-[var(--rule)] p-4">
        <Skeleton variant="text" width="160px" height="20px" className="mb-4" />
        <Skeleton variant="rect" width="100%" height="200px" />
      </div>
    </div>
  </div>
);

export const LessonSkeleton = () => (
  <div className="min-h-[100dvh]">
    <div className="w-full px-2 sm:px-3 lg:px-4 py-4 sm:py-6 space-y-4">
      {/* Tab bar */}
      <div className="bg-white border border-[var(--rule)] p-4">
        <div className="flex gap-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} variant="rect" width="90px" height="36px" />
          ))}
        </div>
      </div>
      {/* Lesson cards */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="bg-white border border-[var(--rule)] p-4 space-y-3">
          <div className="flex items-center justify-between">
            <Skeleton variant="text" width="180px" height="20px" />
            <Skeleton variant="rect" width="70px" height="28px" />
          </div>
          <Skeleton variant="text" count={2} />
        </div>
      ))}
    </div>
  </div>
);

export const GenericPageSkeleton = () => (
  <div className="min-h-[100dvh]">
    <div className="w-full px-2 sm:px-3 lg:px-4 py-4 sm:py-6 space-y-4">
      <div className="bg-white border border-[var(--rule)] p-6 space-y-4">
        <Skeleton variant="text" width="200px" height="24px" />
        <Skeleton variant="text" count={3} />
        <Skeleton variant="rect" width="100%" height="120px" />
        <Skeleton variant="text" count={2} />
      </div>
    </div>
  </div>
);
